import { CompletionBreakdown } from "@help/CompletionBreakdown";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/help/completion")({
  component: CompletionBreakdown,
});
